export enum PatientTrialStyle { 
    BlindedorPlacebo=1,
    Blindedonly=2,
    unblinded=3
}